import React, { useMemo } from 'react';
import { BiEdit, BiPlus, BiTrash } from 'react-icons/bi';

import Bouton from '../../UI/Bouton/Bouton';
import Tableau from '../../UI/tableau/Tableau';

import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import S from './TableauFunctions.module.scss';

const COLUMN_CONFIG = [
  ['id_function', 'ID', 100, null, 80],
  ['name', 'Nom', 200, null, 200, 1],
  ['actions', 'Actions', 150, null, 140, 0],
];

const createColumn = (field, text, width, formatter, minWidth, flex) => ({
  dataField: field,
  text,
  sort: field !== 'actions',
  ...(width ? { width } : {}),
  ...(minWidth ? { minWidth } : {}),
  ...(flex ? { flex } : {}),
  ...(formatter ? { formatter } : {}),
});

const TableauFunctions = ({
  functionSelectionnee,
  editerFunction,
  creerFunction,
  supprimerFunction,
  functions,
}) => {
  const handleEdit = (e, func) => {
    e.stopPropagation();
    if (typeof editerFunction === 'function') editerFunction(func);
  };

  const handleDelete = (e, func) => {
    e.stopPropagation();
    if (typeof supprimerFunction === 'function') {
      supprimerFunction(func);
    }
  };

  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    hideSelectAll: true,
    hideSelectColumn: true,
    style: () => ({ background: '#eeb214', color: 'black' }),
    onSelect: (row) => {
      console.log(row);
      if (typeof functionSelectionnee === 'function')
        return functionSelectionnee(row);
    },
  };

  const columns = useMemo(
    () =>
      COLUMN_CONFIG.map(([field, text, width, formatter, minWidth, flex]) => {
        if (field === 'id_function') {
          return createColumn(
            field,
            text,
            width,
            (cell, row) => row.id_function || row.id,
            minWidth,
            flex
          );
        }

        if (field === 'actions') {
          return createColumn(
            field,
            text,
            width,
            (cell, row) => (
              <div className={S.actionsContainer}>
                <Bouton
                  type={type_btn.secondary}
                  rond={true}
                  taille="small"
                  cliquer={(e) => handleEdit(e, row)}
                  ajoutClass={`${S.actionButton} ${S.editButton}`}
                >
                  <BiEdit size={14} />
                </Bouton>
                <Bouton
                  type={type_btn.danger}
                  rond={true}
                  taille="small"
                  cliquer={(e) => handleDelete(e, row)}
                  ajoutClass={`${S.actionButton} ${S.deleteButton}`}
                >
                  <BiTrash size={14} />
                </Bouton>
              </div>
            ),
            minWidth,
            flex
          );
        }

        return createColumn(field, text, width, formatter, minWidth, flex);
      }),
    [handleDelete, handleEdit]
  );

  return (
    <div className={S.conteneurTableau}>
      <div className={S.filtresContainer}>
        <Bouton
          type={type_btn.success}
          cliquer={creerFunction}
          ajoutClass={S.boutonCreer}
        >
          <BiPlus size={16} /> Créer une fonction
        </Bouton>
      </div>
      <div className={S.tableauContainer}>
        <Tableau
          donnees={functions}
          colonnes={columns}
          selectionnerLignes={selectRow}
          cleLigne="id_function"
          messageVide="Aucune fonction trouvée"
          ajoutClass={S.tableau}
          hide_general_search={false}
        />
      </div>
    </div>
  );
};

export default TableauFunctions;
